interface CaseIdentityLike {
  caseNumber?: string | null;
  parentCaseNumber?: string | null;
  parentCase?: { caseNumber?: string | null } | null;
}

interface SlideIdentityLike {
  number?: string | null;
  physicalSlideNumber?: number | null;
}

const LEGACY_SLIDE_NUMBER_PATTERN = /(?:^|-)(\d+)$/;

export function getDisplayCaseNumber(caseEntity?: CaseIdentityLike | null) {
  return (
    caseEntity?.parentCaseNumber?.trim() ||
    caseEntity?.parentCase?.caseNumber?.trim() ||
    caseEntity?.caseNumber?.trim() ||
    ""
  );
}

export function getPhysicalSlideNumber(slide: SlideIdentityLike) {
  if (slide.physicalSlideNumber && slide.physicalSlideNumber > 0) {
    return String(slide.physicalSlideNumber);
  }
  const number = String(slide.number ?? "").trim();
  return number.match(LEGACY_SLIDE_NUMBER_PATTERN)?.[1] ?? number;
}
